import { COMMON_LANGUAGES } from 'lib/datasets/languages';
import { Organization } from 'lib/types/company';
import {
  ILearningCenterMetadata,
  ILearningCenterUserSettingsView,
} from './types';

export const DEFAULT_LANGUAGE_SETTING: string = COMMON_LANGUAGES.EN;

export const DEFAULT_USER_SETTINGS: ILearningCenterUserSettingsView = {
  AUTO_ADVANCE: false,
  LANGUAGE: DEFAULT_LANGUAGE_SETTING,
  TRANSCRIPTS: false,
};

export const DEFAULT_METADATA: ILearningCenterMetadata = {
  userId: undefined,
  companyId: undefined,
  companyName: undefined,
  companyUrlAlias: undefined,
  isAdmin: false,
  isHotlineEnabled: false,
  isManagerHubReportTreeDisabled: false,
  isPolicyBotAvailable: false,
  organization: Organization.ETHENA,
  theme: undefined,
  userSettings: DEFAULT_USER_SETTINGS,
  scormHideEthenaReferences: false,
  scormHideRoleAndLocationUpdate: false,
  hideFeedbackSlide: false,
  hideTimerDisclaimerSlide: false,
  ssoConnection: undefined,
  hiddenUserSettings: [],
};
